import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from '../api/axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();
const navigate = useNavigate;
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({type_compte:'Visiteur'});
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
   

    // Configurer axios pour Sanctum

    const checkAuth = async () => {
        try {
            const response = await axios.get('/api/user');
            setUser(response.data);
            setIsAuthenticated(true);
        } catch (error) {
            setUser({ type_compte: 'Visiteur' });
            setIsAuthenticated(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth(); // Vérifie si un cookie de session existe au chargement
    }, []);

    const logout = async () => {
        try {
        await axios.post('/logout');
    } catch (error) {
        console.error("Erreur lors de la déconnexion :", error.response?.data || error.message);
        // Vous pouvez choisir de jeter l'erreur pour la gérer dans le composant
        throw error; 
    } finally {
        // Optionnel : On déconnecte l'utilisateur localement même si le serveur échoue
        setUser({type_compte: 'Visiteur'});
        setIsAuthenticated(false);
    }
        
    };

    return (
        <AuthContext.Provider value={{ user, setUser, isAuthenticated, setIsAuthenticated, logout, loading}}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

// Hook personnalisé pour utiliser le contexte facilement
export const useAuth = () => useContext(AuthContext);
